// @flow
import type { Node } from 'react';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import commonStyle from '../../../components/OrderCommon.scss';
import boxStyle from '../../../../../assets/styles/box.scss';
import style from './OrderCanceled.scss';

type Props = {
  +buildProducts: () => Node;
  +buildSummary: () => Node;
};

export default class OrderCanceled extends Component<Props> {
  render() {
    const { buildProducts, buildSummary } = this.props;
    return (
      <Fragment>
        <section className={commonStyle.topWrap}>
          <FormattedMessage id="order.sale.canceled.title">{
            txt => <h2 className={commonStyle.topTitle}>{txt}</h2>
          }</FormattedMessage>
        </section>
        <main className={commonStyle.mainWrap}>
          <section className={classNames(commonStyle.wrap, commonStyle.leftWrap)}>
            <section className={classNames(boxStyle.box, style.box)}>
              <FormattedMessage id="order.sale.canceled.text">{
                txt => <p className={classNames(boxStyle.subtitle, boxStyle.noSpace)}>{txt}</p>
              }</FormattedMessage>
            </section>
            {buildProducts()}
          </section>
          <section className={classNames(commonStyle.wrap, commonStyle.rightWrap)}>
            {buildSummary()}
          </section>
        </main>
      </Fragment>
    );
  }
}

OrderCanceled.propTypes = {
  buildProducts: PropTypes.func.isRequired,
  buildSummary: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/order/Sale/order-canceled/components/OrderCanceled.jsx